import { QueryHookOptions, QueryResult, useQuery } from '@apollo/client';
import { gql, OperationVariables } from '@apollo/client/core';

interface Data {
  me: {
    id: string;
    username: string;
    firstName: string;
    roles: string[];
  };
}

const QUERY = gql`
  query me {
    me {
      id
      roles
      username
      firstName
    }
  }
`;

export const useMeQuery = (
  options?: QueryHookOptions<Data, OperationVariables>
): QueryResult<Data, OperationVariables> =>
  useQuery<Data, OperationVariables>(QUERY, options);
